module.exports = __webpack_public_path__ + "img/1.2.0d2e5b37.png";